
import { defineComponent } from 'vue'
import SidebarLayout from '../../layouts/SidebarLayout.vue'
import VButton from '../../components/base/button/VButton.vue'
import IndexForm from '../../components/form/productindex/IndexForm.vue'
import store , { ActionTypes } from "../../store";
import { mapState } from 'vuex'
import { User } from "/@src/types";
export default defineComponent({
  name: 'StrategyCreate',
  components: {
    IndexForm,
    VButton,
    SidebarLayout
  },
  beforeRouteUpdate (to, from, next) {
    store.dispatch(ActionTypes.FETCH_PRODUCTS).then(() => next())
  },
  data() {
    return {
      LoggedIn : false
    }
  },

    computed:{
      ...mapState([
        'products','user', 'users'
      ]),

    },
  created(){
    this.loadUsers(this.users)
  },
  methods: {
    loadUsers( users : Array<User[]> ) {
      return store.dispatch( ActionTypes.FETCH_USERS )
    }
  }
})

